module.exports = __webpack_public_path__ + "img/dashboard2-fullGrey.ecfc1dc8.svg";